import { memo, useMemo } from 'react';
import { EdgeProps, useStore, ReactFlowState } from '@xyflow/react';
import { useGraphStore } from '../../store/graphStore';

interface CurvedEdgeProps extends EdgeProps {
  data?: {
    edgeIndex?: number;
    totalEdges?: number;
  };
}

export const CurvedEdge = memo(({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style,
  markerEnd,
  data,
}: CurvedEdgeProps) => {
  const isBeautified = useGraphStore((s) => s.isBeautified);

  // Create path - straight when normal, smooth bezier curve when beautified
  const path = useMemo(() => {
    return `M ${sourceX} ${sourceY} L ${targetX} ${targetY}`;
  }, [sourceX, sourceY, targetX, targetY]);

  return (
    <path
      id={id}
      className="react-flow__edge-path"
      d={path}
      style={{
        ...style,
        fill: 'none',
        strokeWidth: 8,
        strokeDasharray: 'none',
        strokeLinecap: 'round',
        opacity: 1,
      }}
      markerEnd={markerEnd}
    />
  );
});

CurvedEdge.displayName = 'CurvedEdge';
